import './main.less';
import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, FieldArray } from 'redux-form';
import cn from 'classname';
import noop from 'lodash/noop';

import AddField from './add-field';
import Affiliate from './affiliate';
import Offers from './offers';

const Form = props => (
	<div className="affiliates-container">
		<form action="" className="ui-form" onSubmit={props.handleSubmit(data => props.submitAffiliatesForm(data))}>
			<FieldArray name="child_affiliates" {...props} component={RenderAffiliatesArray} />
			<div className="ui-form__element affiliates-form__buttons-wrap">
				<button type="submit" className="ui-btn ui-btn-primary">
					{props.intl('Save')}
				</button>
				{props.childAffiliates &&
					props.childAffiliates.length < props.childAffiliatesAmount && (
					<button className="ui-btn ui-btn-secondary" onClick={props.showMore}>
						{props.intl('Show more')}
					</button>
				)}
			</div>
		</form>
	</div>
);

const RenderAffiliatesArray = props => (
	<div className="entity-wrap">
		<AddField {...props} onClick={props.toggleAddAffiliateSelect} />

		{props.fields.length > 0 && (
			<table className="entity-wrap__table">
				<thead className="entity-wrap__table-head">
					<tr>
						<th className="affiliate">Affiliate</th>
						<th className="offers-count">Offers</th>
					</tr>
				</thead>
				<tbody className="entity-wrap__table-body">
					{props.fields.map((parentName, index, fields) => {
						const res = [];
						const shouldShowOffers = props.listOfActiveAffiliatesPanIndex.indexOf(index) > -1;

						const onToggleOffersPan = props.fields.get(index)
							? shouldShowOffers
								? props.hideAffiliateOffers
								: handleShowOffers(props.fields.get(index), props.fetchAffiliateOffers)
							: noop;

						// affiliates row
						res.push(
							<Affiliate
								key={index}
								className={cn({
									'is-show-offers': shouldShowOffers,
									'modify-cursor-pointer': props.fields.get(index)['offer_ids'].length
								})}
								type="affiliate"
								parentName={parentName}
								index={index}
								intl={props.intl}
								placeholder={props.intl('Select affiliate')}
								fields={props.fields}
								entityLookup={props.affiliatesLookups}
								onToggleOffersPan={onToggleOffersPan}
								onFetchOffers={props.fetchAffiliateOffers}
								onDeleteAffiliate={props.deleteAffiliate}
								offersAmount={props.fields.get(index)['offer_ids'].length}
								shouldShowOffers={shouldShowOffers}
								shownTargetPixelHeightsMap={props.shownTargetPixelHeightsMap}
							/>,
							<tr key={`affiliates-padding-${index}`} className="padding-tr" />
						);

						// offers row
						shouldShowOffers &&
							res.push(
								<FieldArray
									name={`${parentName}.offers`}
									intl={props.intl}
									parentIndex={index}
									component={Offers}
									affiliatesOffersLookups={props.affiliatesOffersLookups}
									payoutCurrencies={props.payoutCurrencies}
									onChangeCurrency={props.changeCurrency}
									selectedCurrenciesPanIndexMap={props.selectedCurrenciesPanIndexMap}
									listOfActiveOffersPanIndex={props.listOfActiveOffersPanIndex}
									showOfferTargets={props.showOfferTargets}
									hideOfferTargets={props.hideOfferTargets}
									updateShownTargetsPixelHeights={props.updateShownTargetsPixelHeights}
									nullifyBoostOnSubmit={props.nullifyBoostOnSubmit}
									nullifiedBoosts={props.nullifiedBoosts}
								/>
							);

						return res;
					})}
				</tbody>
			</table>
		)}
	</div>
);

Form.propTypes = {
	handleSubmit: PropTypes.func,
	submitAffiliatesForm: PropTypes.func,
	childAffiliates: PropTypes.array,
	childAffiliatesAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	showMore: PropTypes.func,
	intl: PropTypes.func
};

RenderAffiliatesArray.propTypes = {
	fields: PropTypes.object,
	intl: PropTypes.func,
	affiliatesLookups: PropTypes.func,
	affiliatesOffersLookups: PropTypes.func,
	selectedCurrenciesPanIndexMap: PropTypes.object,
	changeCurrency: PropTypes.func,
	hideOfferTargets: PropTypes.func,
	showOfferTargets: PropTypes.func,
	toggleAddAffiliateSelect: PropTypes.func,
	updateShownTargetsPixelHeights: PropTypes.func,
	nullifyBoostOnSubmit: PropTypes.func,
	nullifiedBoosts: PropTypes.array
};

const handleShowOffers = (entity, onFetchOffers) => index => {
	onFetchOffers(index, entity.affiliate[0]);
};

export default reduxForm({
	form: 'childAffiliatesForm',
	enableReinitialize: true,
	keepDirtyOnReinitialize: true,
	destroyOnUnmount: false
})(Form);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates/components/profile/affiliates/main.js